// import { getDomain, isSplickyDomain } from "@app/common/utils/url";
import { getFontStyling } from "./utils/getFontStyling";
import { darkenColor } from "./utils/darkenColor";

const splickyColors = {
  primary: {
    default: "#6555EE",
    hover: "#5423E7",
    active: "#6555EE",
    focus: "#6555EE",
    disabled: "#C6B6F7",
    error: "#F53D6B",
  },
  secondary: {
    default: "#22C8AE",
    hover: "#00BC9F",
    active: "#22C8AE",
    focus: "#22C8AE",
    disabled: "#A7DFD4",
    error: "#F53D6B",
  },
} as const;

export enum StateVariants {
  Default = "default",
  Hover = "hover",
  Active = "active",
  Focus = "focus",
  Disabled = "disabled",
  Error = "error",
}

const getColour = (
  variant: SplickyColorVariants = "primary",
  state: StateVariants = StateVariants.Default
): string => splickyColors[variant][state] || splickyColors.primary.default;

export const theme = {
  colors: {
    primary: getColour("primary"),
    secondary: getColour("secondary"),
  },
  getColour,
  getFontStyling,
  darkenColor,
  palette: {
    black: "#121217",
    grey: "#A9A9BC",
    grey2: "#4F4F4F",
    lightGrey: "#D1D1DB",
    paleGrey: "#F7F7F8",
    darkGrey: "#6C6C89",
    white: "#ffffff",
    blueBell: "#E9F0FF",
    lila: "#C6D5FF",
  },
  utils: {
    isSplickyDomain: true,
  },
} as const;

export type SplickyTheme = typeof theme;
export type SplickyColors = typeof splickyColors;
export type SplickyColorVariants = keyof SplickyColors;
